var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"text-right",attrs:{"inputmode":"numeric","type":"text","size":this.size,"name":_vm.name},domProps:{"value":_vm.computedValue},on:{"update:value":function($event){_vm.computedValue=$event},"blur":_vm.formatField,"input":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }